export default {
  getAllRestreams: state => state.restreams,
  getRestreamById: state => id => state.restreams.find(r => r.liveVideoId === id),
}
